import Vue from 'vue'
import { API_URL } from '../../api'
import InvestorReportsFilter from '../../filters/InvestorReportsFilter';
const state = {
    investorReportCreate: {
        createdInvestorReport: null,
        creatingInvestorReport: false,
        createInvestorReportStatus: null
    },
    investorReportUpdate: {
        updatedInvestorReport: null,
        updatingInvestorReport: false,
        updateInvestorReportStatus: null
    },
    investorReportDelete: {
        deletingInvestorReport: false,
        deleteInvestorReportStatus: null
    },
    investorReportSearch: {
        investorReportsCount: null,
        investorReportsPaginated: [],
        investorReports: [],
        searchingInvestorReports: false,
        searchInvestorReportStatus: null
    },
}
const mutations = {
    ['SET_INVESTOR_REPORT_CREATE'](state, change) {
        state.investorReportCreate = { ...state.investorReportCreate, ...change };
    },
    ['SET_INVESTOR_REPORT_UPDATE'](state, change) {
        state.investorReportUpdate = { ...state.investorReportUpdate, ...change };
    },
    ['SET_INVESTOR_REPORT_DELETE'](state, change) {
        state.investorReportDelete = { ...state.investorReportDelete, ...change };
    },
    ['SET_INVESTOR_REPORT_SEARCH'](state, change) {
        state.investorReportSearch = { ...state.investorReportSearch, ...change };
    },

}
const actions = {
    createInvestorReport: ({ commit }, payload) => {
        commit('SET_INVESTOR_REPORT_CREATE', { createInvestorReportStatus: null, createdInvestorReport: null, creatingInvestorReport: true })
        return Vue.http.post(API_URL + '/investors/reports/create', payload).then(response => {
            commit('SET_INVESTOR_REPORT_CREATE', { createInvestorReportStatus: 'success', createdInvestorReport: response.body.results.investorReport });
        }).catch(response => {
            commit('SET_INVESTOR_REPORT_CREATE', { createInvestorReportStatus: 'failed' });
        }).finally(() => {
            commit('SET_INVESTOR_REPORT_CREATE', { creatingInvestorReport: false });
        });
    },
    updateInvestorReport: ({ commit }, payload) => {
        commit('SET_INVESTOR_REPORT_UPDATE', { updateInvestorReportStatus: null, updatedInvestorReport: null, updatingInvestorReport: true })
        return Vue.http.post(API_URL + '/investors/reports/update/' + payload.id, payload)
            .then(response => {
                commit('SET_INVESTOR_REPORT_UPDATE', { updateInvestorReportStatus: 'success', updatedInvestorReport: response.body.results.investorReport });
            })
            .catch(response => {
                commit('SET_INVESTOR_REPORT_UPDATE', { updateInvestorReportStatus: 'failed' });
            })
            .finally(() => {
                commit('SET_INVESTOR_REPORT_UPDATE', { updatingInvestorReport: false });
            })
    },
    confirmInvestorReport: ({ commit }, payload) => {
        commit('SET_INVESTOR_REPORT_UPDATE', { updateInvestorReportStatus: null, updatedInvestorReport: null, updatingInvestorReport: true })
        return Vue.http.post(API_URL + '/investors/reports/confirm/' + payload.id, payload)
            .then(response => {
                commit('SET_INVESTOR_REPORT_UPDATE', { updateInvestorReportStatus: 'success', updatedInvestorReport: response.body.results.investorReport });
            })
            .catch(response => {
                commit('SET_INVESTOR_REPORT_UPDATE', { updateInvestorReportStatus: 'failed' });
            })
            .finally(() => {
                commit('SET_INVESTOR_REPORT_UPDATE', { updatingInvestorReport: false });
            })
    },

    deleteInvestorReport: ({ commit }, id) => {
        commit('SET_INVESTOR_REPORT_DELETE', { deleteInvestorReportStatus: null, deletedInvestorReport: null, deletingInvestorReport: true })
        return Vue.http.delete(API_URL + '/investors/reports/delete/' + id).then(response => {
            commit('SET_INVESTOR_REPORT_DELETE', { deleteInvestorReportStatus: 'success' });
        }).catch(response => {
            commit('SET_INVESTOR_REPORT_DELETE', { deleteInvestorReportStatus: 'failed' });
        }).finally(() => {
            commit('SET_INVESTOR_REPORT_DELETE', { deletingInvestorReport: false });
        })
    },
    searchInvestorReports: ({ commit }, payload = { filter: InvestorReportsFilter(), resultMode: 'default' }) => {
        commit('SET_INVESTOR_REPORT_SEARCH', { searchInvestorReportStatus: null, searchInvestorReport: null, searchingInvestorReports: true })
        let filerJson = JSON.stringify(payload.filter);
        switch (payload.resultMode) {
            case 'count': payload.resultMode = 1; break;
            case 'paginated': payload.resultMode = 2; break;
            case 'paginatedPersist': payload.resultMode = 21; break;
            default: payload.resultMode = 0; break;
        }
        var params = '?query=' + encodeURIComponent(filerJson) + '&result_mode=' + payload.resultMode;
        return Vue.http.get(API_URL + '/investors/reports' + params).then(response => {
            let investorReports = response.body.results.investorReports
            let years = payload.filter.years.map(Number); // Convert strings to numbers


            if (years.length > 0) {
                investorReports = investorReports.filter(report =>
                    years.includes(report.plan_report.year)
                );
            }
            if (payload.resultMode == 1) {
                commit('SET_INVESTOR_REPORT_SEARCH', { searchInvestorReportStatus: 'success', investorReportsCount: investorReports });

            } else if (payload.resultMode == 2) {
                commit('SET_INVESTOR_REPORT_SEARCH', { searchInvestorReportStatus: 'success', investorReportsPaginated: investorReports });

            } else {
                commit('SET_INVESTOR_REPORT_SEARCH', { searchInvestorReportStatus: 'success', investorReports: investorReports });
            }
        }).catch(response => {
            commit('SET_INVESTOR_REPORT_SEARCH', { searchInvestorReportStatus: 'failed' });
        }).finally(() => {
            commit('SET_INVESTOR_REPORT_SEARCH', { searchingInvestorReports: false });
        })
    },
}
export default {
    state, mutations, actions
} 



// WEBPACK FOOTER //
// ./resources/js/store/modules/investorReportStore.js